import { render, staticRenderFns } from "./PriceFeature.vue?vue&type=template&id=7b957d5a&"
import script from "./PriceFeature.vue?vue&type=script&lang=ts&"
export * from "./PriceFeature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PriceFeature.vue"
export default component.exports